import React, { useState, useEffect, useContext } from "react";

import axios from "axios";

import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import Button from "components/CustomButtons/Button.js";
import FloatInput from "components/Input/FloatInput.js";
import TextInput from "components/Input/TextInput.js";
import AutocompleteInput from "components/Input/AutocompleteInput.js";
import Chip from "@mui/material/Chip";
import UserService from "services/UserService";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import { batiment } from "variables/patrimoine.js";
import { makeStyles } from "@mui/styles";
import { getSite, getFiles } from "services/ConfigServices";
import { NotificationManager } from 'react-notifications';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: '#fff',
    display: "flex",
  },
  tabs: {
    borderRight: `1px solid rgba(0, 0, 0, 0.12)`,
  },
  tab: {
    paddingLeft: "0rem",
    marginLeft: "0rem",
    flexDirection: "column",
    textAlign: "left",
    display: "grid",
    justifyContent: "left",
    alignItems: "flex-start",
    maxWidth: "3rem",
  },
  input: {
    display: "flex",
    flexDirection: "column",
    margin: "1rem 0rem 0rem",
  },
  inputTitle: {
    margin: "0.2rem 0rem 0.05rem 0.5rem",
  },
  select: {
    display: "flex",
    flexDirection: "column",
    margin: "1rem 0.5rem",
  },
  switch: {
    marginLeft: "0.5rem",
  },
}));

function Structure(props) {
  const permis = JSON.parse(localStorage.getItem('permission')) || [];
  const realestateupdate = permis.includes("realestate_update");
  const [uponderation, setUponderation] = useState("");
  const [ustructure, setUstructure] = useState("");
  const [airdeperdition, setAirdeperdition] = useState("");
  const [thermicaldeperdition, setThermicaldeperdition] = useState("");
  const [jointwall, setJointwall] = useState("");
  const [associatedfiles, setAssociatedfiles] = useState("");
  const [comments, setComments] = useState("");
  const [description, setDescription] = useState("");

  const [gedList, setGedList] = useState([{ name: String, id: Number }]);

  const appContext = useContext(AdvancedSearchContext);
  const { chartIdGroup } = appContext;

  const handleUponderationChange = (event) => { setUponderation(event.target.value); };
  const handleUstructureChange = (event) => { setUstructure(event.target.value); };
  const handleAirdeperditionChange = (event) => { setAirdeperdition(event.target.value); };
  const handleThermicaldeperditionChange = (event) => { setThermicaldeperdition(event.target.value); };
  const handleJointwallChange = (event) => { setJointwall(event.target.value); };
  const handleAssociatedfilesChange = (newValue) => {
    let newArray = [];
    for (let i = 0; i < newValue.length; i++) {
      newArray.push(newValue[i]);
    }
    setAssociatedfiles(newArray);
  };
  const handleCommentsChange = (event) => { setComments(event.target.value); };
  const handleDescriptionChange = (event) => { setDescription(event.target.value); };

  const selectedGed = () => {
    let gedCardId = [];
    let getGedNames;
    if (associatedfiles !== undefined) {
      for (let i = 0; i < associatedfiles.length; i++) {
        gedCardId.push(associatedfiles[i].fileId);
      }
      getGedNames = gedList.filter((gedList) =>
        gedCardId.includes(gedList.fileId)
      );
    }
    return getGedNames;
  };

  useEffect(() => {
    axios
      .get(
        getFiles(chartIdGroup),
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
          },
        }
      )
      .then((res) => {
        setGedList(res.data.collection);
      });
  }, []);

  useEffect(() => {
    axios
      .get(
        getSite(chartIdGroup, "structure.synthesis"),
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
          },
        }
      )
      .then((res) => {
        setAssociatedfiles(res.data.detail.structure?.synthesis?.associatedfiles || []);
        setUponderation(res.data.detail.structure?.synthesis?.uponderation);
        setUstructure(res.data.detail.structure?.synthesis?.ustructure);
        setAirdeperdition(res.data.detail.structure?.synthesis?.airdeperdition);
        setThermicaldeperdition(res.data.detail.structure?.synthesis?.thermicaldeperdition);
        setJointwall(res.data.detail.structure?.synthesis?.jointwall);
        setComments(res.data.detail.structure?.synthesis?.comments);
        setDescription(res.data.detail.structure?.synthesis?.description);

      })
      .catch(() => { });
  }, []);

  const handleEdit = () => {
    axios
      .put(
        getSite(chartIdGroup, "structure.synthesis"),
        {
          uponderation,
          ustructure,
          airdeperdition,
          thermicaldeperdition,
          jointwall,
          associatedfiles,
          comments,
          description,
        },
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
            'Content-Type': "application/json; charset=utf-8",
          },
        }
      )
      .then((res) => {
        if (res.status == 200) {
          NotificationManager.success("Modifications enregistrées");
        }
        else {
          NotificationManager.error("Une erreur est survenue");
        }
      })
      .catch(() => {
        NotificationManager.error("Une erreur est survenue");
      });
  };

  const classes = useStyles();

  return (
    <div>
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <div>
            <FloatInput
              inputTitle={batiment.structure.synthesis.uponderation}
              floatInput={uponderation}
              handleFloatInputChange={handleUponderationChange}
              disabled={!realestateupdate}
            />
          </div>
          <div>
            <TextInput
              inputTitle={batiment.structure.synthesis.ustructure}
              textInput={ustructure}
              handleTextInputChange={handleUstructureChange}
              disabled={!realestateupdate}
            />
          </div>

          <div>
            <FloatInput
              inputTitle={batiment.structure.synthesis.airdeperdition}
              floatInput={airdeperdition}
              handleFloatInputChange={handleAirdeperditionChange}
              disabled={!realestateupdate}
            />
          </div>

          <div>
            <FloatInput
              inputTitle={batiment.structure.synthesis.thermicaldeperdition}
              floatInput={thermicaldeperdition}
              handleFloatInputChange={handleThermicaldeperditionChange}
              disabled={!realestateupdate}
            />
          </div>

          <div>
            <TextInput
              inputTitle={batiment.structure.synthesis.jointwall}
              textInput={jointwall}
              handleTextInputChange={handleJointwallChange}
              disabled={!realestateupdate}
            />
          </div>

          <div>
            <AutocompleteInput
              disabled={!realestateupdate}
              inputTitle={batiment.structure.synthesis.associatedfiles}
              selected={selectedGed()}
              list={gedList}
              handleChange={(_, newValue) =>
                handleAssociatedfilesChange(newValue)
              }
              renderTags={(tagValue, getTagProps) =>
                tagValue.map((option, index) => (
                  <Chip label={option.title} {...getTagProps({ index })} />
                ))
              }
            />
          </div>

          <div>
            <TextInput
              disabled={!realestateupdate}
              inputTitle={batiment.structure.synthesis.comments}
              textInput={comments}
              handleTextInputChange={handleCommentsChange}
            />
          </div>

          <div>
            <TextInput
              disabled={!realestateupdate}
              inputTitle={batiment.structure.synthesis.description}
              textInput={description}
              handleTextInputChange={handleDescriptionChange}
            />
          </div>
        </GridItem>
        <GridItem xs={12} sm={12} md={12}>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-end",
              marginTop: "1rem",
              marginLeft: "auto",
              marginRight: "0.2rem",
            }}
          >
            {realestateupdate ? <Button
              style={{
                color: "#FFFFFF",
                backgroundColor: "#91C73C",
                fontWeight: "normal",
                fontWeight: "bold",
                height: "40px",
                fontSize: "0.75rem",
                padding: "5px 15px",
                marginRight: "5px",
                marginBottom: "0px",
                marginTop: "0px",
                fontFamily: '"Source Sans Pro",sans-serif',
              }}
              onClick={() => {
                handleEdit();
              }}
            >
              Enregistrer
            </Button> : <></>}
          </div>
        </GridItem>
      </GridContainer>

    </div>
  );
}

export default Structure;
